import React from "react";
import { formatDuration } from "./analyticsUtils";

const BarGroup = ({ dayData, animate, maxSeconds }) => {
  const day = dayData?.day || "";
  const quizSeconds = Math.max(0, Number(dayData?.quizSeconds) || 0);
  const readSeconds = Math.max(0, Number(dayData?.readSeconds) || 0);

  const safeMax = Math.max(60, Number(maxSeconds) || 60);

  const calcHeight = (secs) => {
    if (secs <= 0) return 0;
    const pct = (secs / safeMax) * 100;
    return Math.min(100, Math.max(2, pct));
  };

  const quizHeight = calcHeight(quizSeconds);
  const readHeight = calcHeight(readSeconds);
  const totalSeconds = quizSeconds + readSeconds;

  return (
    <div className="w-full h-full flex flex-col items-center justify-end gap-1 group cursor-pointer relative">
      {/* Tooltip */}
      <div className="absolute -top-16 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition pointer-events-none z-10">
        <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg whitespace-nowrap">
          <div className="font-bold mb-1">{day}</div>

          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-sm bg-brand-500"></span>
            <span>Quiz: {formatDuration(quizSeconds)}</span>
          </div>

          <div className="flex items-center gap-2 mt-1">
            <span className="inline-block w-2 h-2 rounded-sm bg-purple-400"></span>
            <span>Reading: {formatDuration(readSeconds)}</span>
          </div>

          <div className="text-[11px] text-gray-300 mt-1">Total: {formatDuration(totalSeconds)}</div>
        </div>
      </div>

      {/* Bars */}
      <div className="w-full flex-1 flex gap-1 items-end justify-center relative">
        <div
          className="w-3 md:w-4 bg-brand-500 rounded-t-sm group-hover:bg-brand-600 transition-all duration-700 ease-out"
          style={{ height: animate ? `${quizHeight}%` : "0%" }}
        />
        <div
          className="w-3 md:w-4 bg-purple-400 rounded-t-sm group-hover:bg-purple-500 transition-all duration-700 ease-out"
          style={{ height: animate ? `${readHeight}%` : "0%" }}
        />
      </div>

      <span className="text-xs text-gray-400 font-medium mt-2">{day}</span>
    </div>
  );
};

export default BarGroup;
